var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container mt-5"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticStyle: {
      "height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-3",
    attrs: {
      "placeholder": _vm.$t('ar_common_search')
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('b-form-checkbox', {
    staticClass: "mb-2 ml-1",
    class: {
      'ml-3': !_vm.isFlattenData
    },
    on: {
      "change": _vm.toggleSelectAll
    },
    model: {
      value: _vm.selectAll,
      callback: function ($$v) {
        _vm.selectAll = $$v;
      },
      expression: "selectAll"
    }
  }, [_c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.$t("ar_client_select_all")))])]), _vm._l(_vm.filteredData, function (item) {
    return _c('div', {
      key: item.Id
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [!_vm.isFlattenData ? _c('ez-icon', {
      attrs: {
        "size": "24",
        "icon": _vm.isCollapsed(item.Id) ? 'ezAr-icon-chevron-right' : 'ezAr-icon-chevron-down'
      },
      on: {
        "click": function ($event) {
          return _vm.toggleCollapse(item.Id);
        }
      }
    }) : _vm._e(), _c('b-form-checkbox', {
      staticStyle: {
        "margin-left": "12px"
      },
      attrs: {
        "value": item.Id
      },
      on: {
        "change": function ($event) {
          return _vm.selectParentChildren(item.Id);
        }
      },
      model: {
        value: _vm.selectedParents,
        callback: function ($$v) {
          _vm.selectedParents = $$v;
        },
        expression: "selectedParents"
      }
    }), _c('h5', {
      staticClass: "mt-1",
      staticStyle: {
        "margin-left": "8px"
      }
    }, [_vm._v(_vm._s(item.NameVi))])], 1), !_vm.isFlattenData ? _c('b-collapse', {
      attrs: {
        "id": 'child-' + item.Id,
        "visible": !_vm.isCollapsed(item.Id)
      }
    }, [_c('b-list-group', {
      attrs: {
        "flush": ""
      }
    }, _vm._l(item.Permission, function (childItem) {
      return _c('b-list-group-item', {
        key: childItem.Id
      }, [_c('b-form-checkbox', {
        staticClass: "ml-3",
        attrs: {
          "value": childItem
        },
        model: {
          value: _vm.selectedData,
          callback: function ($$v) {
            _vm.selectedData = $$v;
          },
          expression: "selectedData"
        }
      }, [_c('span', {
        staticClass: "ml-1"
      }, [_vm._v(_vm._s(childItem.NameVi))])])], 1);
    }), 1)], 1) : _vm._e()], 1);
  })], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }